import Handler from "../Handler";
class UpdatePlayerCountHandler extends Handler {
  constructor(service) {
    super(service);
  }
  execute(data) {

    // upc# New Protocol Data
    // { 
    //    "playerCountMap":[
    //        {"roomId":81601,"playerCount":0},
    //        {"roomId":81201,"playerCount":0},
    //        {"roomId":0,"playerCount":1},
    //        {"roomId":81701,"playerCount":0},
    //        {"roomId":81401,"playerCount":0},
    //        {"roomId":81501,"playerCount":0},
    //        {"roomId":81101,"playerCount":0}
    //    ]}


    // upc# Old Protocol Data
    /**
     * {
        "playerCountMap": [
          {
            "gameDefId": 605,
            "playerCount": 45
          },
          {
            "gameDefId": 502,
            "playerCount": 55
          }
        ]
      }
     */
    let receivedData = JSON.parse(data);
    if (receivedData) {
      this.service.processUpdatePlayerCount(receivedData);
    }
  }
}

export default UpdatePlayerCountHandler;
